import type {AssetDTO, AssetSummaryDTO, NonEmptyArray} from '@sollapay/types';

/** ponytail: the ledger balance name, activity/Slack rows, pay link and headers each carry one asset — the purchase's first; revisit when a purchase spans several. */
export function getPrimaryAsset<T>({assets}: {assets: NonEmptyArray<T>}): T {
  return assets[0];
}

export function toAssetSummary({attachments: _attachments, ...asset}: AssetDTO): AssetSummaryDTO {
  return asset;
}
